export default {
    // ========================================================
    //  Typography
    // ========================================================
    GLOBAL_HEADING_FONT_FAMILY: 'GLOBAL_HEADING_FONT_FAMILY',
    GLOBAL_BODY_FONT_FAMILY: 'GLOBAL_BODY_FONT_FAMILY',
    // ========================================================
    //  Colors
    // ========================================================
    GLOBAL_FONT_COLOR: 'GLOBAL_FONT_COLOR',
    GLOBAL_LINK_COLOR: 'GLOBAL_LINK_COLOR',
    GLOBAL_SUCCESS_COLOR: 'GLOBAL_SUCCESS_COLOR',
    GLOBAL_WARNING_COLOR: 'GLOBAL_WARNING_COLOR',
    GLOBAL_ERROR_COLOR: 'GLOBAL_ERROR_COLOR',
    GLOBAL_DESTRUCTIVE_COLOR: 'GLOBAL_DESTRUCTIVE_COLOR',
    GLOBAL_INFO_COLOR: 'GLOBAL_INFO_COLOR',
    GLOBAL_PRIMARY_COLOR: 'GLOBAL_PRIMARY_COLOR',
    GLOBAL_SECONDARY_COLOR: 'GLOBAL_SECONDARY_COLOR',
    GLOBAL_TERTIARY_COLOR: 'GLOBAL_TERTIARY_COLOR',
    // ========================================================
    //  Button - Shared
    // ========================================================
    GLOBAL_BTN_BORDER_WIDTH: 'GLOBAL_BTN_BORDER_WIDTH',
    GLOBAL_BTN_BORDER_RADIUS: 'GLOBAL_BTN_BORDER_RADIUS',
    // ========================================================
    //  Primary Button
    // ========================================================
    GLOBAL_PRIMARY_BTN_BG_COLOR: 'GLOBAL_PRIMARY_BTN_BG_COLOR',
    GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR: 'GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR',
    GLOBAL_PRIMARY_BTN_BG_COLOR_START: 'GLOBAL_PRIMARY_BTN_BG_COLOR_START',
    GLOBAL_PRIMARY_BTN_BG_COLOR_END: 'GLOBAL_PRIMARY_BTN_BG_COLOR_END',
    GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_START:
        'GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_START',
    GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_END:
        'GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_END',
    GLOBAL_PRIMARY_BTN_LIN_GRAD_BG_COLOR:
        'GLOBAL_PRIMARY_BTN_LIN_GRAD_BG_COLOR',
    GLOBAL_PRIMARY_BTN_TEXT_COLOR: 'GLOBAL_PRIMARY_BTN_TEXT_COLOR',
    GLOBAL_PRIMARY_BTN_BORDER_COLOR: 'GLOBAL_PRIMARY_BTN_BORDER_COLOR',
    // ========================================================
    //  Secondary Button
    // ========================================================
    GLOBAL_SECONDARY_BTN_BG_COLOR: 'GLOBAL_SECONDARY_BTN_BG_COLOR',
    GLOBAL_SECONDARY_BTN_BG_COLOR_START: 'GLOBAL_SECONDARY_BTN_BG_COLOR_START',
    GLOBAL_SECONDARY_BTN_BG_COLOR_END: 'GLOBAL_SECONDARY_BTN_BG_COLOR_END',
    GLOBAL_SECONDARY_BTN_LIN_GRAD_BG_COLOR:
        'GLOBAL_SECONDARY_BTN_LIN_GRAD_BG_COLOR',
    GLOBAL_SECONDARY_BTN_TEXT_COLOR: 'GLOBAL_SECONDARY_BTN_TEXT_COLOR',
    GLOBAL_SECONDARY_BTN_BORDER_COLOR: 'GLOBAL_SECONDARY_BTN_BORDER_COLOR',
    // ========================================================
    //  Tertiary Button
    // ========================================================
    GLOBAL_TERTIARY_BTN_BG_COLOR: 'GLOBAL_TERTIARY_BTN_BG_COLOR',
    GLOBAL_TERTIARY_BTN_BG_COLOR_START: 'GLOBAL_TERTIARY_BTN_BG_COLOR_START',
    GLOBAL_TERTIARY_BTN_BG_COLOR_END: 'GLOBAL_TERTIARY_BTN_BG_COLOR_END',
    GLOBAL_TERTIARY_BTN_LIN_GRAD_BG_COLOR:
        'GLOBAL_TERTIARY_BTN_LIN_GRAD_BG_COLOR',
    GLOBAL_TERTIARY_BTN_TEXT_COLOR: 'GLOBAL_TERTIARY_BTN_TEXT_COLOR',
    GLOBAL_TERTIARY_BTN_BORDER_COLOR: 'GLOBAL_TERTIARY_BTN_BORDER_COLOR',
    // ========================================================
    //  Destructive Primary Button
    // ========================================================
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR',
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_START:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_START',
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_END:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_END',
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_LIN_GRAD_BG_COLOR:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_LIN_GRAD_BG_COLOR',
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_TEXT_COLOR:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_TEXT_COLOR',
    GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BORDER_COLOR:
        'GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BORDER_COLOR',
    // ========================================================
    //  Destructive Secondary Button
    // ========================================================
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR',
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_START:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_START',
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_END:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_END',
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_LIN_GRAD_BG_COLOR:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_LIN_GRAD_BG_COLOR',
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_TEXT_COLOR:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_TEXT_COLOR',
    GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BORDER_COLOR:
        'GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BORDER_COLOR',
    // ========================================================
    //  Masthead
    // ========================================================
    MASTHEAD_BG: 'MASTHEAD_BG',
    MASTHEAD_BG_COLOR_END: 'MASTHEAD_BG_COLOR_END',
    MASTHEAD_BG_COLOR_START: 'MASTHEAD_BG_COLOR_START',
    MASTHEAD_BG_IMG: 'MASTHEAD_BG_IMG',
    MASTHEAD_BG_IMG_FITS_TO_AREA: 'MASTHEAD_BG_IMG_FITS_TO_AREA',
    MASTHEAD_BG_IMG_POSITION: 'MASTHEAD_BG_IMG_POSITION',
    MASTHEAD_BG_IMG_REPEAT: 'MASTHEAD_BG_IMG_REPEAT',
    MASTHEAD_BG_IMG_SIZE: 'MASTHEAD_BG_IMG_SIZE',
    MASTHEAD_LOGO_LARGE: 'MASTHEAD_LOGO_LARGE',
    MASTHEAD_LOGO_SMALL: 'MASTHEAD_LOGO_SMALL',
    MASTHEAD_TEXT_COLOR: 'MASTHEAD_TEXT_COLOR',
    // ========================================================
    //  Main Navigation
    // ========================================================
    MAIN_NAV_BG_COLOR: 'MAIN_NAV_BG_COLOR',
    MAIN_NAV_TEXT_COLOR: 'MAIN_NAV_TEXT_COLOR',
    MAIN_NAV_BORDER_COLOR: 'MAIN_NAV_BORDER_COLOR',
    MAIN_NAV_SUB_NAV_BG_COLOR: 'MAIN_NAV_SUB_NAV_BG_COLOR',
    MAIN_NAV_SUB_NAV_LINK_COLOR: 'MAIN_NAV_SUB_NAV_LINK_COLOR',
    MAIN_NAV_SUB_NAV_HEADING_COLOR: 'MAIN_NAV_SUB_NAV_HEADING_COLOR',
    // ========================================================
    //  Utility Navigation
    // ========================================================
    UTILITY_NAV_BG_COLOR: 'UTILITY_NAV_BG_COLOR',
    UTILITY_NAV_LINK_COLOR: 'UTILITY_NAV_LINK_COLOR',
    // ========================================================
    //  Featured Navigation
    // ========================================================
    // FEATURED_NAV_BG_COLOR: 'FEATURED_NAV_BG_COLOR',
    FEATURED_NAV_LINK_COLOR: 'FEATURED_NAV_LINK_COLOR',
    FEATURED_NAV_FLAG_BG_COLOR: 'FEATURED_NAV_FLAG_BG_COLOR',
    FEATURED_NAV_FLAG_TEXT_COLOR: 'FEATURED_NAV_FLAG_TEXT_COLOR',
    // ========================================================
    // Body
    // ========================================================
    BODY_BG_COLOR_END: 'BODY_BG_COLOR_END',
    BODY_BG_COLOR_START: 'BODY_BG_COLOR_START',
    BODY_BG_IMG: 'BODY_BG_IMG',
    BODY_BG: 'BODY_BG',
    BODY_BG_IMG_FITS_TO_AREA: 'BODY_BG_IMG_FITS_TO_AREA',
    BODY_BG_IMG_POSITION: 'BODY_BG_IMG_POSITION',
    BODY_BG_IMG_REPEAT: 'BODY_BG_IMG_REPEAT',
    BODY_BG_IMG_SIZE: 'BODY_BG_IMG_SIZE',
    BODY_TEXT_COLOR: 'BODY_TEXT_COLOR',
    // ========================================================
    //  Widgets
    // ========================================================
    WIDGETS_HEADER_BG_COLOR: 'WIDGETS_HEADER_BG_COLOR',
    WIDGETS_HEADER_TEXT_COLOR: 'WIDGETS_HEADER_TEXT_COLOR',
    WIDGETS_BORDER_COLOR: 'WIDGETS_BORDER_COLOR',
    WIDGETS_BORDER_RADIUS: 'WIDGETS_BORDER_RADIUS',
    WIDGETS_BORDER_WIDTH: 'WIDGETS_BORDER_WIDTH',
    WIDGETS_BG_OPACITY: 'WIDGETS_BG_OPACITY',
    WIDGETS_DROP_SHADOW: 'WIDGETS_DROP_SHADOW',
    WIDGETS_HAS_DROP_SHADOW: 'WIDGETS_HAS_DROP_SHADOW',
    // ========================================================
    //  Footer
    // ========================================================
    FOOTER_BG_COLOR_START: 'FOOTER_BG_COLOR_START',
    FOOTER_BG_COLOR_END: 'FOOTER_BG_COLOR_END',
    FOOTER_BG_IMG: 'FOOTER_BG_IMG',
    FOOTER_BG_IMG_FITS_TO_AREA: 'FOOTER_BG_IMG_FITS_TO_AREA',
    FOOTER_BG_IMG_REPEAT: 'FOOTER_BG_IMG_REPEAT',
    FOOTER_BG_IMG_POSITION: 'FOOTER_BG_IMG_POSITION',
    FOOTER_LINK_COLOR: 'FOOTER_LINK_COLOR',
    FOOTER_TEXT_COLOR: 'FOOTER_TEXT_COLOR',
};
